import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { Schema } from 'prosemirror-model';
import { createSlice } from '../context';
import { InitReady } from '../internal-plugin';
import { createTimer } from '../timing';
export const SchemaReady = createTimer('schemaReady');
export const schemaCtx = createSlice({}, 'schema');
export const nodesCtx = createSlice([], 'nodes');
export const marksCtx = createSlice([], 'marks');
export const schemaTimerCtx = createSlice([], 'schemaTimer');
export const schema = (pre) => {
    pre.inject(schemaCtx).inject(nodesCtx).inject(marksCtx).inject(schemaTimerCtx, [InitReady]).record(SchemaReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(schemaTimerCtx);
        const getAtom = (x) => Object.fromEntries(x.map(({ id, schema }) => [id, schema]));
        const nodes = getAtom(ctx.get(nodesCtx));
        const marks = getAtom(ctx.get(marksCtx));
        ctx.set(schemaCtx, new Schema({
            nodes,
            marks,
        }));
        ctx.done(SchemaReady);
    });
};
//# sourceMappingURL=schema.js.map